import chooseNextProperId from 'helpers/chooseNextProperId'
import { doorControllerDefaults } from 'helpers/accessControl/defaults'

export default function addDoorController(state, action) {
  const { location } = action
  const { entities: { doorControllers: { allIds, byId } } } = state
  const id = chooseNextProperId(allIds)

  const doorController = Object.assign({}, doorControllerDefaults, {
    name: `Door Controller ${Object.values(byId).filter(controller => !controller.isExpansion).length + 1}`,
    location,
    id
  })

  return Object.assign({}, state, {
    entities: {
      ...state.entities,
      doorControllers: {
        byId: {
          ...byId,
          [id]: doorController
        },
        allIds: allIds.concat(id)
      }
    },
    currentEntity: {
      type: 'doorController',
      id
    },
    ui: {
      ...state.ui,
      sidebarView: 'doorControllerDetails'
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/addDoorController.js